import React from "react";
import Button from "../Button";
import Modal from "../Modal";

export const ModalDelete = ({action, close, show, loading, text, level}) => {
    return (
        <Modal 
            className={`modal-delete`}
            level={level}
            show={show}
            title={`Confirmar exclusão`}
            close={close}
            footer={
                <>
                    <Button type={`primary`} size={`small`} svg={`delete-small-white`} text={`Confirmar`} action={action} loading={loading}/>
                    {!loading &&
                        <Button type={`secondary`} size={`small`} text={`Cancelar`} action={close}/>
                    }
                </>
            }
        >
            <div className="section">
                <img src={ require(`../../assets/images/gifs/delete.gif`)} />
                <p>{text ?? 'Tem certeza que deseja realizar esta exclusão?'}</p>
            </div>
        </Modal>
    );
}